import React from "react";
import {formatDateTime} from "@/utils/DateUtils";
import {FormattedMessage} from "react-intl";

type Props = {
    clockedIn: boolean,
    date: string,
};

const TimeEntryItem = ({clockedIn, date}: Props) => {
    return (
        <li
            className={"border border-gray-200 dark:border-gray-700 py-2 px-4 rounded flex flex-row items-center justify-between"}>
            <div className={"flex flex-row items-center justify-start gap-1"}>
                <div
                    className={
                        clockedIn
                            ? "text-green-600 dark:text-green-400"
                            : "text-red-600 dark:text-red-400"
                    }
                >
                    •
                </div>
                <p>
                    <FormattedMessage id={clockedIn ? "clockedIn" : "clockedOut"}/>
                </p>
            </div>
            <time className={"tabular-nums text-[85%]"}>
                {formatDateTime(date)}
            </time>
        </li>
    );
};

export default TimeEntryItem;